const getOrderLineDosTo3 = ({ orderLine, value, index }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (index !== undefined) {
    const indexOrderLine = orderLine ? orderLine[index] : null;
    if (indexOrderLine) {
      const date = indexOrderLine['Date of Service To'] || indexOrderLine.dateOfServiceTo;
      return date.replace(/[/]/g, '').substring(6, 8);
    }

    return null;
  }

  return orderLine
    ? orderLine.map((item) => {
      const date = item['Date of Service To'] || item.dateOfServiceTo;
      return date.replace(/[/]/g, '').substring(6, 8);
    }).join(', ')
    : null;
};

export default getOrderLineDosTo3;



// WEBPACK FOOTER //
// ./src/utils/print/getOrderLineDosTo3.js